import { Routes } from '@angular/router';
import { AboutcompanycontainerComponent } from './aboutcompanycontainer/aboutcompanycontainer.component';
import { AnnualReportComponent } from './annual-report/annual-report.component';
import { SocialResponsibilityComponent } from './social-responsibility/social-responsibility.component';
import { AboutKalpitaPageComponent } from './about-kalpita-page/about-kalpita-page.component';
// import { PrivacyPolicyComponent } from './legal/privacy-policy/privacy-policy.component';
// import { CookiePolicyComponent } from './legal/cookie-policy/cookie-policy.component';

export const ABOUTCOMPANY_ROUTES: Routes = [
  {
    path: '',
    component: AboutcompanycontainerComponent,
    children: [
      {
        path: 'kalpita-annual-reports',
        component: AnnualReportComponent,
        data: {
          title: 'Kalpita Technologies Annual Reports | Business Growth',
          description:
            `Explore Kalpita Technologies' Annual Reports, highlighting business growth, tech trends, 
            financial highlights, industry impact & innovation-driven strategies.`,
          keywords: 'Annual Reports, Business Growth'
        }
      },
      { path: 'kalpita-csr', component: SocialResponsibilityComponent },
      { path: 'about-kalpita-technologies', component: AboutKalpitaPageComponent },
      // {
      //   path: "kalpita-privacy-policy", component: PrivacyPolicyComponent,
      //   data: {
      //     title: 'Privacy Policy - Protecting Your Data | Kalpita Technologies',
      //     description: 'Kalpita Technologies is committed to protecting your privacy. Read our Privacy Policy to know how we collect, store, use, and secure your personal data.',
      //     keywords: 'Privacy Policy, Data Security, Compliance, User Experience, Manage Preferences, Transparency, Data Protection'
      //   }
      // },
      // {
      //   path: "kalpita-cookie-policy", component: CookiePolicyComponent,
      //   data: {
      //     title: 'Cookie Policy - How We Use Cookies | Kalpita technologies',
      //     description: 'Our Cookie Policy explains how we use cookies to personalize content, track performance, and improve your browsing experience while protecting your privacy.',
      //     keywords: 'Data Security, Compliance, Cookie Policy, User Experience, Manage Preferences, Transparency, Data Protection'
      //   }
      // }
    ]
  }
];
